import React, { useState, useEffect, useRef } from 'react';
import defaultStates from '../../../src-component/defaultStates';
import { ajaxor4 } from '../../common/basic';

export default props=>{
  const [vID, setID] = useState('');
  const [vPW1, setPW1] = useState('');
  const [vPW2, setPW2] = useState('');
  const [vNickname, setNickname] = useState('');
  const [m1, setM1] = useState('');
  const [m2, setM2] = useState('');
  const [m3, setM3] = useState('');
  const [m4, setM4] = useState('');

  const rID = useRef(null);
  const rPw1 = useRef(null);
  const rPw2 = useRef(null);
  const rNickname = useRef(null); 

  function examID() {
    let sentence = rID.current.value;
    setID(sentence);

    if (sentence.length == 0) setM1(''); else 
    if (1 == 0
      || sentence.split('@').length !== 2
      || sentence.indexOf('.') < 1
      || sentence.length > 255
      || sentence.indexOf(' ') > -1
    ) setM1('올바르지 않은 이메일 형식입니다.');
    else setM1('');
  }

  function examPw1() {
    let sentence = rPw1.current.value;
    setPW1(sentence);


    if (sentence.length == 0) setM2(''); else 
    if (sentence.length < 8) setM2('비밀번호는 8자리 이상이어야 합니다.');
    else if (sentence.search(/[0-9]/) < 0) setM2('비밀번호는 숫자가 최소 1개씩 포함되어야 합니다.');

    // 0227 설계
    // ~!@#$%^&*()-_?
    // ~!@#\$%\^&\*\(\)-_\?

    // 기초
    // else if (sentence.search(/[^0-9a-zA-Z]/) < 0) setM2('비밀번호는 특수문자가 최소 1개씩 포함되어야 합니다.');
    // 최초
    // else if (sentence.search(/(\.|-|_)/) < 0) setM2('비밀번호는 특수문자가 최소 1개씩 포함되어야 합니다.');
    // 0227
    // else if (sentence.search(/(~|!|@|#|\$|%|\^|&|\*|\(|\)|-|_|\?)/) < 0) setM2('비밀번호는 특수문자가 최소 1개씩 포함되어야 합니다.');

    // 원복(0408)
    // else if (sentence.search(/(\.|-|_)/) < 0) setM2('비밀번호는 특수문자(".", "-", "_" 중 하나)가 최소 1개씩 포함되어야 합니다.');
    // else if (sentence.search(/(~|!|@|#|\$|%|\^|&|\*|\(|\)|\?)/) >= 0) setM2('특수문자는 ".", "-", "_"만 허용됩니다.');
    // else if (sentence.search(/(\.|-|_)/) < 0) setM2('비밀번호는 특수문자가 최소 1개씩 포함되어야 합니다.');

    // 0412 비밀번호 특수문자관련 유효성검사 메시지 교체. '특수문자는 (?=.*[!@#$%^*+=-]) 만 허용됩니다.' 비밀번호에 특수문자 입력은 필수사항
    // else if (sentence.search(/(~|&|\(|\))/) >= 0) setM2('특수문자는 (?=.*[!@#$%^*+=-]) 만 허용됩니다.');
    // else if (sentence.search(/(\?|=|\.|\*|\[|!|@|#|\$|%|\^|\*|\+|=|-|\])/) < 0) setM2('비밀번호는 특수문자가 최소 1개씩 포함되어야 합니다.');

    // 0503 비밀번호 특수문자관련 유효성검사 메시지 교체. '특수문자는 (?=.*[!@#$%^*+=-]) 만 허용됩니다.' 비밀번호에 특수문자 입력은 필수사항
    else if (sentence.split(/[0-9a-zA-Z]|\?|=|\.|\*|\[|!|@|#|\$|%|\^|\*|\+|=|-|\]/).join('').length > 0) setM2('특수문자는 (?=.*[!@#$%^*+=-]) 만 허용됩니다.');
    else if (sentence.search(/(\?|=|\.|\*|\[|!|@|#|\$|%|\^|\*|\+|=|-|\])/) < 0) setM2('비밀번호는 특수문자가 최소 1개씩 포함되어야 합니다.');

    else if (sentence.length > 25) setM2('비밀번호는 최대 25자까지 입력이 가능합니다.');
    else setM2('');
  }

  function examPw2() {
    let sentence = rPw2.current.value;

    setPW2(rPw2.current.value);

    if (sentence.length == 0) setM3(''); else 
    if (rPw1.current.value != rPw2.current.value) setM3('비밀번호와 비밀번호 확인은 같게 입력해야 합니다.');
    else setM3('');
  }

  function examNickname(){
    let sentence = rNickname.current.value;
    setNickname(sentence);

    // if (sentence.replace(/[^0-9a-zA-Z \.\-_]/, "") != sentence) setM4("특수문자는 '-', '_', '.'만 입력 가능합니다.");

    // 0412 한글허용하자.
    // editprofile.js에서는 없앤 기록이 있으니 주의
    if (sentence.replace(/[^0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣 \.\-_]/, "") != sentence) setM4("특수문자는 '-', '_', '.'만 입력 가능합니다.");

    else if (sentence.search(/\s/) > -1) setM4('공백은 포함되면 안됩니다.');
    else if (sentence.search(/(\.|-|_)/) == 0) setM4('첫 글자에 특수문자가 입력되면 안됩니다.');
    // else if (sentence.search(/(\.|-|_)/) < 0) setM4('중복된 사용자 이름입니다.');
    else if (sentence.length > 12) setM4('닉네임은 최대 12자까지 입력이 가능합니다.');
    else setM4('');
  }


  function goJoin(){

    if (typeof vNickname == "undefined" || vNickname == "") {
      alert("닉네임은 필수 입니다.");
      return;
    }
    // var data={
    //   email: vID,
    //   username: vNickname, // db테이블에 있으면 안된다. 주의.
    //   password: vPW1,
    //   user_agreement: ($('#cb1').is(":checked") && $('#cb2').is(":checked")) ? 'on' : '', // on 주의
    // };
    // console.log(": ", data);

    if (!($('#cb1').is(":checked") && $('#cb2').is(":checked"))){
      alert('이용약관, 개인정보처리방침에 동의하여야 합니다.');
      return;
    }

    if ((m1+m2+m3+m4).length>1) {
      alert('입력항목들을 다시 확인해 주시기 바랍니다.');
      return;
    }


    ajaxor4({
      url:'/auth/register',
      data: {
        type: 'email',

        email: vID,
        username: vNickname, // db테이블에 있으면 안된다. 주의.
        password: vPW1,
        user_agreement: ($('#cb1').is(":checked") && $('#cb2').is(":checked")) ? 'on' : '', // on 주의
      },
      callback:callback,
    });

    function callback(rd){
      if(typeof rd=='undefined'){
        alert("회원가입에 실패하였습니다."); // 동일한 닉넴도 안됨
        return;
      }

      alert("가입해 주셔서 감사합니다."); // 동일한 닉넴도 안됨

      //////////////////////////바로 자동 로그인 재확인 0811
      const formData = new FormData();
      formData.append('email', vID);
      formData.append('password', vPW1);

      $.ajax({
        type: 'POST',
        url: `${defaultStates.host}/auth/login/email`,
        data: formData,
        contentType: false,
        dataType: 'json',
        processData: false,
        headers: {
          'Client-Type': 'webapp',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': document.location.host,
          "Authorization": "Bearer " + localStorage[defaultStates.localStorageKey],
        },
        success: (res) => {
          // console.log("res: ", res);
          // {"meta":{"code":200},"data":{"user":{"id":254044,"user_group_id":0,"email":"lcg2004@naver.com","username":"lcaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaag","nickname":"CAMSCON Inspirer","intro":"자기소개1","gender":1,"birthday":"1234-12-01","instagram":"aer@@daf.com","website":"http://naver.com","slug":null,"api_token":"C6oVw7c2ZmXdO1QveQjwr9.....","preferences":null,"created_at":"2019-09-27 11:09:04","updated_at":"2020-01-04 16:11:31","profile_picture":[],"is_inspirer":false,"is_admin":false}}}
          if (res.meta && +res.meta.code === 200) {
            localStorage[defaultStates.localStorageKey] = res.data.user.api_token;
            if (!res.data.user.username) {
              // console.log("로그인성공(사용자명 없음)");
              // browserHistory.push('/set-username');// 기존: 사용자명 입력으로 이동.
              Router.push('/set-username');
            } else {
              // browserHistory.push('/');
              location.href = '/';
            }
          } else if (res.meta && +res.meta.code === 422) {
            if (res.data.email) {
              alert(res.data.email[0]);
            }
          } else if (res.meta && +res.meta.code === 400 || +res.meta.code === 440) {
            alert('비밀번호가 틀렸습니다.');
          } else {
            alert('로그인에 실패했습니다.\n다시 시도해주세요.');
          }
        },
        error: (x, s, e) => {
          // lcg
          // console.log(x, s, e);
          alert('로그인에 실패했습니다.');
        }
      });
      //////////////////////////로그인 끝
      // location.href="/"; // 성공; 0811 어짜피 로그인성공시 홈으로 리디렉션한다. 여기서 또하면 풀린다.
    }
  }


  //카카오로그인***********************
  function goKakao() {
    console.log("로그인 창을 띄웁니다.: ");

    Kakao.Auth.login({
      success: function (authObj) {
        // 로그인 성공시, API를 호출합니다.
        console.log("Kakao.Auth.login. 로그인 성공시, API를 호출합니다.:", JSON.stringify(authObj));
        Kakao.API.request({
          url: '/v2/user/me',
          success: function (res) {
            console.log('request.success: : ', JSON.stringify(res));
            onKaKaoSuccess(authObj.access_token, res.id);
          },
          fail: function (error) {
            console.log('request.fail: ', JSON.stringify(error));
          }
        });
      },
      fail: function (err) {
        console.log('Kakao.Auth.login.fail: ', JSON.stringify(err));
      }
    });
  };

  function onKaKaoSuccess(kakao_access_token, kakao_user_id) {// id, nickname, access_token, psa_url) {
    console.log("onKaKaoSucSuccess: ", kakao_access_token, kakao_user_id);

    console.log("ajaxor4: ");
    ajaxor4({
      url: "/auth/login/kakao",
      data: {
        kakao_access_token: kakao_access_token,
        kakao_user_id: kakao_user_id,
      },
      callback: authLoginKaKao,
    });
  }

  function authLoginKaKao(rd) {
    console.log("authLoginKaKao: ");

    if (typeof rd == 'undefined') {
      // alert('카카오로그인 회원이 아닙니다.');
      return;
    }

    console.log("rd: ", rd);

    localStorage[defaultStates.localStorageKey] = rd.user.api_token;
    if (!rd.user.username) {
      // username 이 없으면, 과거 회원가입페이지 같은데로 갔다.
      // browserHistory.push('/set-username');
    }
    // browserHistory.push('/');

    if (process.browser) location.href = "/";
  }

  useEffect(() => {
    setID('');
    setPW1('');
    setPW2('');
    setNickname('');
    setM1('');
    setM2('');
    setM3('');
    setM4('');
    $('#cb1').prop('checked', false);
    $('#cb2').prop('checked', false);

    $('.this-content.popup.fullom').scrollTop(0);
    return () => { ; };
  }, [props.display]);

  
  return (<div className="Join this-content popup fullom "
    onMouseDown={e => e.stopPropagation()}
  >
    <style jsx>{`
.Join.this-content{

    width: 460px;
    padding: 45px 60px;

    margin: auto;
    background-color: white;

    overflow-y: auto;
    position: fixed;
    top: 50px;
    bottom: 0;
    margin: 0 auto;
    left: 0;
    right: 0;

    max-height: 682px;
    box-sizing: border-box;

    text-align: left;

}

.x{
    float:right;
    /* margin: -20px -20px 0 0; */
    margin: -30px -40px 0 0;
}

.logo{
    text-align:center;
}

.title{
    font-size: 16px;
    text-align: center;
    color: #343a40;
}

.button42{
    width: 100%;
    height: 42px;
    text-align: center;
    /* padding-top: 12px; */
    margin: 10px 0;
    vertical-align:middle;
    padding: 0;
    line-height: 42px;

}

.button42 img{
  vertical-align:middle;
}

.button1{
    background-color: #325a9f;
    font-size: 14px;
    color: white;
}

.button2{
    background-color: #feea0e;
    font-size: 14px;
    color: #343a40;
}

.or{
  text-align: center;
}

.label1 {
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.25px;
  color: #868e96;
}

.input1{
    width: 100%;
    /* height: 24px; */
    font-size: 14px;
    color: #adb5bd;
    border: none;
    padding-top: 15px;
}

.comment1{
  font-size: 12px;
  color: #55d5ce;
}
.sentence1{
  font-size: 14px;
  color: #343a40;
  text-align:right;
}
.button3{
    background-color: #212529;
    color: white;
    font-size: 14px;
}

.sentence2{
  font-size: 14px;
  color: #343a40;
  text-align:center;
}


.checkbox1{
    font-size: 12px;
    color: #343a40;
}

.see{
    font-size: 12px;
    float: right;
    color: #343a40;

}


.horizon-bar-half{
    width: 45%;
    height: 1px;
    background-color: #e9ecef;
    margin: 10px 0 0 0;
}

.horizon-bar-half.left{
  float:left;
}

.horizon-bar-half.right{
  float:right;
}

@media all and (max-width:606px) {
  .Join.this-content{
    top: 0;
    width: auto;
  }

  .x{
    margin: 0;
  }

  .logo{
    padding: 40px 0 0 0;
  }
}

div.checkbox1 > *{
  vertical-align: text-top;
}

.horizon-bar222 {
  width: 100%;
  height: 1px;
  background-color: #ced4da;
  margin: 8px 0 8px;
}

`}</style>
    {/* <div className="x" onClick={props.hide}><img src="/assets/images2/x_dark.svg" /></div> */}
    <div className="x">
      <a onClick={props.hide}><img src="/assets/images2/x_dark.svg" /></a>
    </div>

    {/* <div className="">&nbsp;</div> */}
    <div className="logo"><img src="/assets/images/logo-camscon.svg" /></div>
    {/* <div className="">&nbsp;</div>{/* 로그인팝업의 로고위치가 맞다. */}
    {/* 0510 밑의간격을 넓혀달라 */}
    <div className="">&nbsp;</div>
    <div className="">&nbsp;</div>

    {/* 그리고, "당신의 패션사진, 데일리룩을 공유하세요."가 디바이스별로 다 깨지는데 이 텍스트 삭제해주셔도 될것같아요~ */}
    {/* <div className="title">당신의 패션사진, 데일리룩을 공유하세요.</div> */}
    <div className="title">&nbsp;</div>
    <div className="">&nbsp;</div>
    {/* <div className="button42 button1">&nbsp;
      <img src="/assets/images/path-3.svg" />&nbsp;&nbsp;페이스북으로 시작하기
    </div> */}
    <div className="button42 button2 mouse-aa" onClick={goKakao}>
      <img src="/assets/images/ico-kakao.svg" />&nbsp;&nbsp;카카오로 시작하기
    </div>
    <div className="or">
      <div className="horizon-bar-half left" /> or <div className="horizon-bar-half right" />
    </div>

    <div className="">&nbsp;</div>
    <div className="label1">이메일(아이디)</div>
    <input className="input1" placeholder="아이디로 사용하실 이메일 입력, 예)example@gmail.com"
      ref={rID} value={vID}
      onChange={e => setID(e.target.value)}
      onBlur={examID}
    />
    <div className="horizon-bar222" />
    <div className="comment1">{m1}&nbsp;</div>
    <div className="">&nbsp;</div>
    <div className="label1">비밀번호</div>
    <input className="input1" type="password" autoComplete="off" placeholder="영문, 숫자, 특수문자 각각 1회 포함(8자 이상)"
      ref={rPw1} value={vPW1}
      // onChange={(e) => examPw1()} // 0418 매번검사하지말고 다음인풋으로 넘어가면 검사하자.
      onChange={e => setPW1(e.target.value)}
      onBlur={examPw1}
    />
    <div className="horizon-bar222" />
    <div className=""></div>
    <div className="comment1">{m2}&nbsp;</div>

    {/* <div className="">&nbsp;</div> */}
    <input className="input1" type="password" autoComplete="off" placeholder="비밀번호 확인, 동일한 비밀번호 재입력"
      ref={rPw2} value={vPW2} onChange={(e) => examPw2()}
    />
    <div className="horizon-bar222" />
    <div className=""></div>
    <div className="comment1">{m3}&nbsp;</div>

    <div className="">&nbsp;</div>
    <div className="label1">닉네임</div>
    <input className="input1" placeholder="최대 12자, 공백 허용안됨"
      ref={rNickname} value={vNickname} onChange={(e) => examNickname()}
    />
    <div className="horizon-bar222" />
    <div className=""></div>
    <div className="comment1">{m4}&nbsp;</div>

    <div className="">&nbsp;</div>
    <div className="">&nbsp;</div>
    <div className="checkbox1">
      <input id="cb1" type="checkbox" />
      이용약관 동의
        <div className="see"><a href="/htmls/terms.html" target="_blank">약관보기</a></div>
    </div>
    <div className="checkbox1">
      <input id="cb2" type="checkbox" />
      개인정보처리방침 동의
        <div className="see"><a href="/htmls/privatepolicy.html" target="_blank">약관보기</a></div>
    </div>

    <div className="">&nbsp;</div>
    <a onClick={goJoin}>
      <div className="button42 button3">회원가입</div>
    </a>
    <div className="">&nbsp;</div>
    <a onClick={() => {
      $('.this-content').scrollTop(0);
      props.setLogin();
    }}>
      <div className="sentence2">이미 캠스콘 회원 이신가요?</div>
    </a>
    <div className="">&nbsp;</div>



  </div>);

}